// Derived from dojo/string — Copyright (c) The JS Foundation, BSD-3-Clause. See ../../LICENSE.
// mds-dojo — dojo/string. Faithful port of substitute() (the template engine
// behind _TemplatedMixin._stringRepl) plus escape/trim/pad/rep.
//
// substitute() semantics that MUST match real dojo (pinned by the oracle e2e):
//   - regex /\$\{([^\s\:\}]*)(?:\:([^\s\:\}]+))?\}/g  → key is a property PATH
//     (dotted), NOT an expression. `${translations.KEY}` is a getObject lookup.
//   - `${}` (empty key) → literal '$'.
//   - value = lang.getObject(key, false, map); optional :format is a fn lookup.
//   - transform(value, key) is applied; if it returns undefined → throw.
//     (_WidgetBaseLite._stringRepl's transform never returns undefined — it maps
//      misses to `#key` — so no throw in practice.)

import lang from './_base/lang';

const ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;', '/': '&#x2F;',
};
const ESCAPE_REGEXP = /[&<>'"\/]/g;

export function escape(str: string): string {
  if (!str) { return ''; }
  return str.replace(ESCAPE_REGEXP, (c) => ESCAPE_MAP[c]);
}

export function substitute(
  template: string,
  map: any,
  transform?: (value: any, key: string) => any,
  thisObject?: any,
): string {
  thisObject = thisObject || (globalThis as any);
  const xf = transform ? lang.hitch(thisObject, transform) : (v: any) => v;

  return template.replace(
    /\$\{([^\s\:\}]*)(?:\:([^\s\:\}]+))?\}/g,
    (_match: string, key: string, format: string) => {
      if (key === '') { return '$'; }
      let value = lang.getObject(key, false, map);
      if (format) {
        value = lang.getObject(format, false, thisObject).call(thisObject, value, key);
      }
      const result = xf(value, key);
      if (typeof result === 'undefined') {
        throw new Error('string.substitute could not find key "' + key + '" in template');
      }
      return result.toString();
    },
  );
}

export function trim(str: string): string {
  return String(str).replace(/^\s+/, '').replace(/\s+$/, '');
}

export function rep(str: string, num: number): string {
  if (num <= 0 || !str) { return ''; }
  let out = '';
  for (let i = 0; i < num; i++) { out += str; }
  return out;
}

export function pad(text: any, size: number, ch?: string, end?: boolean): string {
  ch = ch || '0';
  let out = String(text);
  const padStr = rep(ch, Math.ceil((size - out.length) / ch.length));
  return end ? out + padStr : padStr + out;
}

const string = { escape, substitute, trim, rep, pad };
export default string;
